import type { ITicketSharedWithClientProfileIntegrations } from './TicketSharedWithClientProfileIntegrations.interface';

export default class TicketSharedWithClientProfileIntegrations
  implements ITicketSharedWithClientProfileIntegrations {
  isBankStatementsEnabled: boolean;
  isCashDeckEnabled: boolean;
  isMogoEnabled: boolean;
  isOpenBankingEnabled: boolean;

  static build = (data: ITicketSharedWithClientProfileIntegrations) =>
    new TicketSharedWithClientProfileIntegrations(data);

  static blank = () => new TicketSharedWithClientProfileIntegrations();

  /**
   * Constructor
   * @param {ITicketSharedWith} data
   */
  constructor(data?: ITicketSharedWithClientProfileIntegrations) {
    this.isBankStatementsEnabled = data?.isBankStatementsEnabled === true;
    this.isCashDeckEnabled = data?.isCashDeckEnabled === true;
    this.isMogoEnabled = data?.isMogoEnabled === true;
    this.isOpenBankingEnabled = data?.isOpenBankingEnabled === true;
  }
}
